export const PREPARE_LIST_STORE = 'PREPARE_LIST_STORE'
export const RESET_LIMITATION = 'RESET_LIMITATION'
export const SET_CONFIRM_OPTION = 'SET_CONFIRM_OPTION'
export const SET_AGGREGATE_COLUMN = 'SET_AGGREGATE_COLUMN'
export const SET_AGGREGATE_ROW = 'SET_AGGREGATE_ROW'
export const SET_AGGREGATIONS = 'SET_AGGREGATIONS'
export const SET_AVAILABLE_IN_DETAIL_VIEW = 'SET_AVAILABLE_IN_DETAIL_VIEW'
export const SET_AVAILABLE_IN_LIST = 'SET_AVAILABLE_IN_LIST'
export const SET_COLLAPSED_BUTTONS = 'SET_COLLAPSED_BUTTONS'
export const SET_CURRENT_PARAMETERS = 'SET_CURRENT_PARAMETERS'
export const SET_COLUMN = 'SET_COLUMN'
export const SET_DEFAULT_SHOW_IN_LIST = 'SET_DEFAULT_SHOW_IN_LIST'
export const SET_EXTENDED_OPTIONS = 'SET_EXTENDED_OPTIONS'
export const SET_FETCHING_LIST_DATA = 'SET_FETCHING_LIST_DATA'
export const SET_FILTER = 'SET_FILTER'
export const SET_GROUP_ACTIONS_RUNNING = 'SET_GROUP_ACTIONS_RUNNING'
export const SET_HIDDEN_SEARCH = 'SET_HIDDEN_SEARCH'
export const SET_COLUMNS = 'SET_COLUMNS'
export const SET_LIMITATION = 'SET_LIMITATION'
export const SET_LIST_DATA = 'SET_LIST_DATA'
export const SET_LIST_PROPERTIES = 'SET_LIST_PROPERTIES'
export const SET_LIST_PROPS = 'SET_LIST_PROPS'
export const SET_LIST_VISIBILITY_OPTIONS = 'SET_LIST_VISIBILITY_OPTIONS'
export const SET_MONGO_LIST = 'SET_MONGO_LIST'
export const SET_ORDER = 'SET_ORDER'
export const SET_SEARCH_BAR_COLLAPSED = 'SET_SEARCH_BAR_COLLAPSED'
export const SET_PRIMARY_KEY = 'SET_PRIMARY_KEY'
export const SET_PROCESS_ACTIONS_BUTTONS = 'SET_PROCESS_ACTIONS_BUTTONS'
export const SET_RECORDS_FILTERED = 'SET_RECORDS_FILTERED'
export const SET_RECORDS_TOTAL = 'SET_RECORDS_TOTAL'
export const SET_ROW_CLASSES = 'SET_ROW_CLASSES'
export const SET_ROW_DETAILS = 'SET_ROW_DETAILS'
export const SET_ROW_STYLES = 'SET_ROW_STYLES'
export const SET_COLUMN_CLASSES = 'SET_COLUMN_CLASSES'
export const SET_COLUMN_STYLES = 'SET_COLUMN_STYLES'
export const SET_CELL_CLASSES = 'SET_CELL_CLASSES'
export const SET_CELL_STYLES = 'SET_CELL_STYLES'
export const SET_SEARCH_PARAM = 'SET_SEARCH_PARAM'
export const SET_SEARCH_PARAMS = 'SET_SEARCH_PARAMS'
export const SET_SEARCH_PARAMS_COMP = 'SET_SEARCH_PARAMS_COMP'
export const SET_SELECTED_GROUP_ACTION = 'SET_SELECTED_GROUP_ACTION'
export const SET_SELECTED_QUEUE_ACTION = 'SET_SELECTED_QUEUE_ACTION'
export const SET_SELECTED_ROW = 'SET_SELECTED_ROW'
export const SET_SELECTED_ROWS = 'SET_SELECTED_ROWS'
export const SET_SELECTED_ROWS_FILTER = 'SET_SELECTED_ROWS_FILTER'
export const SET_SHOW_IN_LIST = 'SET_SHOW_IN_LIST'
export const SET_SQL_CHOSEN_BUTTON_PROPS = 'SET_SQL_CHOSEN_BUTTON_PROPS'
export const SET_STORAGE_KEY = 'SET_STORAGE_KEY'
export const SET_UNIVERSAL_FILTER = 'SET_UNIVERSAL_FILTER'
export const SET_VIEW_MODE = 'SET_VIEW_MODE'
export const SET_VISIBILITY = 'SET_VISIBILITY'
export const SET_EXPANDED_ROWS = 'SET_EXPANDED_ROWS'
export const TOGGLE_LIST = 'TOGGLE_LIST'
export const SET_EXPRESSION_CHAIN = 'SET_EXPRESSION_CHAIN'
export const SET_FIELD_PROPERTIES_MAP = 'SET_FIELD_PROPERTIES_MAP'
export const SET_DEFAULT_EXPRESSIONS = 'SET_DEFAULT_EXPRESSIONS'
export const SET_FIELD_PATH_MAP = 'SET_FIELD_PATH_MAP'
export const UPDATE_PROP_BY_NAME = 'UPDATE_PROP_BY_NAME'
export const SET_IS_SAVABLE = 'SET_IS_SAVABLE'
export const SET_TRIGGER_NAME = 'SET_TRIGGER_NAME'
